import { useGetAllTeamsQuery } from 'src/api/redux/teams';

export const useGetAllTeams = () => {
  return useGetAllTeamsQuery();
};

export default useGetAllTeams;
